import { render, staticRenderFns } from "./EditSubmission.vue?vue&type=template&id=6620a3da&scoped=true&"
import script from "./EditSubmission.vue?vue&type=script&lang=js&"
export * from "./EditSubmission.vue?vue&type=script&lang=js&"
import style0 from "./EditSubmission.vue?vue&type=style&index=0&id=6620a3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620a3da",
  null
  
)

component.options.__file = "EditSubmission.vue"
export default component.exports